import React, { useEffect, useState } from 'react';
import { Drawer, Input, Switch, CheckOutlined, CloseOutlined, Button,message, Form, TextArea, useDispatch, useSelector } from '../../AntComponent';
import { saveProjectRole, saveProjectType, saveSponsor,saveProjectMethod } from '../../../store/actions/project-management/ProjectSettingAction';


export default function AddSettings(props) {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const openDrawer = false;
    const id = props.data.id;
    const rowData = props.data.rowData;
    const {success5, addProjRole, success8, success9, success10,addProjMethod,success3, success11,addProjType,success12,addSponsorList } = useSelector(state => state.projectSetting);
    const [typeStatus, setTypeStatus] = useState(rowData?.initiativeTypeStatus=="Active"?true:rowData?.initiativeTypeStatus=="InActive"?false:true);
    const [roleStatus, setRoleStatus] = useState(rowData?.roleStatus=="Active"?true:rowData?.roleStatus=="InActive"?false:true);
    const [sponsorStatus, setSponsorStatus] =useState(rowData?.sponsorStatus=="Active"?true:rowData?.sponsorStatus=="InActive"?false:true);
    const [methodStatus, setMethodStatus] =useState(rowData?.methodStatus=="Active"?true:rowData?.methodStatus=="InActive"?false:true);
    const [showSuccessmsg, setShowsuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success5 : null;
    const [showMethodSuccessmsg, setShowMethodsuccessmsg] = useState(false);
    const methodsuccessmsg = showMethodSuccessmsg ? success9 : null;
    const [showTypeSuccessmsg, setShowTypesuccessmsg] = useState(false);
    const typesuccessmsg = showTypeSuccessmsg ? success3 : null;
    const [showSponsorSuccessmsg, setShowSponsersuccessmsg] = useState(false);
    const sponsorsuccessmsg = showSponsorSuccessmsg ? success12 : null;
    
    useEffect(() => {
        if (sponsorsuccessmsg) {
            if(addSponsorList?.data?.msg =="Saved Successfully"){
                message.success("Sponsor Detail Added Successfully");
                setShowSponsersuccessmsg(false);
            }
            else if(addSponsorList?.message =="Saved Successfully"){
                message.success("Sponsor Detail Updated Successfully");
                setShowSponsersuccessmsg(false);
            }
            
        }
        
    }, [sponsorsuccessmsg]);
    useEffect(() => {
        if (successmsg) {
            if(addProjRole?.data?.msg =="Saved Successfully"){
                message.success("Project Role Added Successfully");
                setShowsuccessmsg(false);
            }
            else if (addProjRole?.data?.msg =="Already Exists"){
                message.warning("Project Role Already Exists");
                setShowsuccessmsg(false);
            }
            else if(addProjRole?.message =="Saved Successfully"){
                message.success("Project Role Updated Successfully");
                setShowsuccessmsg(false);
            }
            
        }
        
    }, [successmsg]);
    useEffect(()=>{
        if (methodsuccessmsg) {
            if(addProjMethod?.data?.msg =="Saved Successfully"){
                message.success("Project Method Added Successfully");
                setShowMethodsuccessmsg(false);
            }
            else if (addProjMethod?.data?.msg =="Already Exists"){
                message.warning("Project Method Already Exists");
                setShowMethodsuccessmsg(false);
            }
            else if(addProjMethod?.data?.msg =="Updated Successfully"){
                message.success("Project Method Updated Successfully");
                setShowMethodsuccessmsg(false);
            }
            
        }
      
    },[methodsuccessmsg])
    useEffect(()=>{
        if (typesuccessmsg) {
            if(addProjType?.data?.msg =="Saved Successfully"){
                message.success("Project Type Added Successfully");
                setShowTypesuccessmsg(false);
            }
            else if (addProjType?.data?.msg =="Already Exists"){
                message.warning("Project Type Already Exists");
                setShowTypesuccessmsg(false);
            }
            else if(addProjType?.message =="Saved Successfully"){
                message.success("Project Type Updated Successfully");
                setShowTypesuccessmsg(false);
            }
            
        }
        
    },[typesuccessmsg])
    const handleCloseDrawer = () => {
        props.data.drawerCallbackFunc(false);
    }

    const submitForm = (values) => {
        let inputJson = {
            "ProMethodID":  id == 1 ? rowData?.proMethodID : 0,
            "MethodName": values.projectMethodName,
            "Description": values.methodDescription,
            "MethodStatus": methodStatus ? "Active" : "InActive",
            "TenantID": props.data.tenantID,
            "LocationID": props.data.locationID,
            "CreatedBy": props.data.appUserID
        }
        let inputJson1 = {
            "InitiativeTypeID": id == 2 ? rowData?.initiativeTypeID : 0,
            "InitiativeType": values.projectTypeName,
            "Description": values.description,
            "InitiativeTypeStatus": typeStatus ? "Active" : "InActive",
            "IsBillable": true,
            "TenantID": props.data.tenantID,
            "LocationID": props.data.locationID,
            "CreatedBy": props.data.appUserID
        }
        let inputJson2 = {
            "ProjectRoleID": id == 3 ? rowData?.projectRoleID : 0,
            "ProjectRole": values.projectRole,
            "Description": values.roleDescription,
            "RoleStatus": roleStatus ? "Active" : "InActive",
            "TenantID": props.data.tenantID,
            "LocationID": props.data.locationID,
            "CreatedBy": props.data.appUserID
        }
        let inputJson3 = {
            "SponsorID": id == 4 ? rowData?.sponsorID : 0,
            "SponsorName": values.sponsorName,
            "Description": values.sponsorDescription,
            "ShortName": values.shortName,
            "ClientStatus": sponsorStatus ? "Active" : "InActive",
            "TenantID": props.data.tenantID,
            "LocationID": props.data.locationID,
            "CreatedBy": props.data.appUserID
        }
        if (props.data.id == 1){
            dispatch(saveProjectMethod(inputJson));
            setShowMethodsuccessmsg(true);
        }else if (props.data.id == 2) {
            dispatch(saveProjectType(inputJson1));
            setShowTypesuccessmsg(true);
        } else if (props.data.id == 3) {
            dispatch(saveProjectRole(inputJson2));
            setShowsuccessmsg(true)
        } else  if (props.data.id == 4) {
            dispatch(saveSponsor(inputJson3))
            setShowSponsersuccessmsg(true);
        }
        handleCloseDrawer();
        form.resetFields();
        const timer = setTimeout(() => {
            props.data.callbackFunc();
        }, 1000);
        return () => clearTimeout(timer);
    }

    const loadFormData = () => {
        form.setFieldsValue({
            projectMethodName: id == 1 ? rowData?.methodName : "",
            methodDescription: id == 1? rowData?.description : "",
            projectTypeName: id == 2 ? rowData?.initiativeType : "",
            description: id == 2 ? rowData?.description : "",
            // status: id==1?rowData?rowData.initiativeTypeStatus=="Active"?true:false:true:true,
            projectRole: id == 3 ? rowData?.projectRole : "",
            roleDescription: id == 3 ? rowData?.description : "",
            // roleStatus: id==2?rowData?.roleStatus=="Active"?true:false:true,
            sponsorName: id == 4 ? rowData?.sponsorName : "",
            shortName: id == 4 ? rowData?.shortName : "",
            // sponsorStatus: id==3?rowData?.sponsorStatus=="Active"?true:false:true,
            sponsorDescription: id == 4 ? rowData?.description : ""
        })
    }

    useEffect(() => {
        loadFormData();
    }, [rowData]);

    return (
        <div>
            <Drawer forceRender  className='TemplateDrawer' title={props.data.title} width={550} placement="right" onClose={handleCloseDrawer} open={props.data.isOpen}>
                <Form
                    form={form}
                    onFinish={submitForm}
                    layout="vertical">
                    {props.data.id == 1 ? <>
                    <Form.Item label="Project Method Name" name="projectMethodName"
                        rules={[{ required: props.data.id == 1 ? true : false, message: "This field is required" }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item label="Description" name="methodDescription" className='col right-col'>
                        <TextArea rows={3} />
                    </Form.Item>
                    <Form.Item label="Status" >
                        <Switch
                        disabled={id==1?true:false}
                            checkedChildren={<CheckOutlined />}
                            unCheckedChildren={<CloseOutlined />}
                            defaultChecked={methodStatus}
                        />
                    </Form.Item>
                </>
                    :props.data.id == 2 ? <>
                        <Form.Item label="Project Type Name" name="projectTypeName"
                            rules={[{ required: props.data.id == 2 ? true : false, message: "This field is required" }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label="Description" name="description" className='col right-col'>
                            <TextArea rows={3} />
                        </Form.Item>
                        <Form.Item label="Status" >
                            <Switch
                            disabled={id==2?true:false}
                                checkedChildren={<CheckOutlined />}
                                unCheckedChildren={<CloseOutlined />}
                                defaultChecked={typeStatus}
                            />
                        </Form.Item>
                    </>
                        :
                        props.data.id == 3 ?
                            <>
                                <Form.Item label="Project Role Name" name="projectRole"
                                    rules={[{ required: props.data.id == 3 ? true : false, message: "This field is required" }]}>
                                    <Input />
                                </Form.Item>
                                <Form.Item label="Status">
                                    <Switch
                                        checkedChildren={<CheckOutlined />}
                                        unCheckedChildren={<CloseOutlined />}
                                        defaultChecked={roleStatus}
                                    />
                                </Form.Item>
                                <Form.Item label="Description" name="roleDescription" className='col right-col'>
                                    <TextArea rows={3} />
                                </Form.Item>
                            </>
                            :props.data.id == 4? <>
                                <Form.Item label="Sponsor Name" name="sponsorName"
                                    rules={[{ required: props.data.id == 4 ? true : false, message: "This field is required" }]}>
                                    <Input />
                                </Form.Item>
                                <Form.Item label="Sponsor Short Name" name="shortName"
                                >
                                    <Input />
                                </Form.Item>
                                <Form.Item label="Status" >
                                    <Switch
                                        checkedChildren={<CheckOutlined />}
                                        unCheckedChildren={<CloseOutlined />}
                                        defaultChecked={sponsorStatus}
                                    />
                                </Form.Item>
                                <Form.Item label="Description" name="sponsorDescription" className='col right-col'>
                                    <TextArea rows={3} />
                                </Form.Item>
                            </> :""
                    }

                    <div className='row m-0 text-end'>
                        <Button className="dlv-cancel-btn me-1" type="primary ms-auto cancel-btn" danger onClick={handleCloseDrawer}>Cancel</Button>
                        <Button className='dlv-save-btn ms-1' type="primary save-btn ms-1" htmlType='submit'>Save</Button>
                    </div>
                </Form>
            </Drawer>
        </div>
    )
}